import React from 'react'
import { ScoreItem } from './weekStyles'
type TeamsColParams = {
  score?: number
}

export const TeamScore: React.FC<React.PropsWithChildren<TeamsColParams>> = ({
  score
}) => {
  if(!score) return null

  return (
    <>
        <ScoreItem>{score}</ScoreItem>
    </>
  )
}
